<template>
    <div class="col-sm-8 col-md-9">
        <div class="recipes--search-toolbar row">
            <div v-if="recipes.length > 0" class="col-xs-12 col-sm-5">
                <span v-if="recipesInfo.total > recipesInfo.perPage"
                    >Visar {{ showingAmount }} av {{ recipesInfo.total }} recept</span
                >
                <span v-else>Visar {{ recipesInfo.total }} av {{ recipesInfo.total }} recept</span>
            </div>
            <span v-if="searchMessage" class="recipes--search-message col-xs-12">{{ searchMessage }}</span>
            <div
                v-if="recipesInfo.prevPageUrl || recipesInfo.nextPageUrl"
                class="col-xs-12 col-sm-7 recipes--pagination recipes--pagination-top"
            >
                <span
                    class="recipes--page-prev"
                    :disabled="isSearching"
                    @click="getPrevPageUrl()"
                    v-if="recipesInfo.prevPageUrl"
                >
                    <svg><use xlink:href="#icon-prev"></use></svg> Föregående sida
                </span>
                <span class="recipes--page-count"
                    >{{ recipesInfo.currentPage }} av {{ recipesInfo.lastPage }}</span
                >
                <span
                    class="recipes--page-next"
                    :disabled="isSearching"
                    @click="getNextPageUrl()"
                    v-if="recipesInfo.nextPageUrl"
                >
                    Nästa sida <svg><use xlink:href="#icon-next"></use></svg>
                </span>
            </div>
        </div>
        <div v-if="!isSearching" class="recipes-row row">
            <article
                :href="`/recept/${recipe.slug}`"
                class="recipe col-sm-6 col-md-4"
                v-for="recipe in recipes"
                :key="recipe.id"
            >
                <a :href="`/recept/${recipe.slug}`" class="recipe--featured-image">
                    <span v-if="recipe.plus_members_only" class="recipe--plus-members-only">
                        <svg class="icon icon-plus">
                            <use xlink:href="#icon-plus"></use>
                        </svg>
                    </span>

                    <span v-if="recipe.is_author_admin" class="recipe--author-admin">M</span>

                    <div :class="recipe.featured_image ? 'recipe--image' : 'recipe--no-image'">
                        <img
                            class="recipe--img"
                            :alt="recipe.title"
                            :src="
                                recipe.featured_image
                                    ? `/assets/media/thumbnail/recipe/${recipe.featured_image}`
                                    : '/assets/images/static/recipes/default-image-recipe.jpg'
                            "
                        />
                    </div>
                </a>

                <header class="recipe--summary">
                    <div class="recipe--tags" v-if="recipe.tag_titles">
                        <span v-for="tag in orderTags(recipe.tag_titles, recipe.tagIds)" :key="tag.id">
                            {{ tag }}
                        </span>
                    </div>
                    <h3 class="recipe--title">
                        <a :href="`/recept/${recipe.slug}`">{{ recipe.title }}</a>
                    </h3>
                    <div class="recipe--author">
                        <span v-if="recipe.username">av {{ recipe.username }}</span>
                        <span v-else>av Anonym</span>
                    </div>
                    <div class="recipe--rating" v-if="recipe.rating_avg">
                        <span
                            class="recipe--rating-result"
                            :style="{
                                width: ratingWidth(recipe.rating_avg, 100) + 'px'
                            }"
                        ></span>
                    </div>
                </header>
                <ul class="recipe--quick-info">
                    <li>
                        <strong>Kcal:</strong>
                        <span>{{ recipe.kcal }}</span>
                    </li>
                    <li>
                        <strong>Kh:</strong>
                        <span>{{ recipe.carbohydrates }} g</span>
                    </li>
                    <li>
                        <strong>F:</strong>
                        <span>{{ recipe.fat }} g</span>
                    </li>
                    <li>
                        <strong>P:</strong>
                        <span>{{ recipe.protein }} g</span>
                    </li>
                </ul>
            </article>
        </div>
        <div v-if="!isSearching" class="recipes--search-toolbar row">
            <div
                v-if="recipesInfo.prevPageUrl || recipesInfo.nextPageUrl"
                class="col-xs-12 recipes--pagination recipes--pagination-bottom"
            >
                <span class="recipes--page-prev" @click="getPrevPageUrl()" v-if="recipesInfo.prevPageUrl">
                    <svg><use xlink:href="#icon-prev"></use></svg> Föregående sida
                </span>
                <span class="recipes--page-count"
                    >{{ recipesInfo.currentPage }} av {{ recipesInfo.lastPage }}</span
                >
                <span class="recipes--page-next" @click="getNextPageUrl()" v-if="recipesInfo.nextPageUrl">
                    Nästa sida <svg><use xlink:href="#icon-next"></use></svg>
                </span>
            </div>
        </div>
        <div v-if="isSearching">
            <loader />
        </div>
    </div>
</template>

<script>
import state from '../state.js';

import axios from 'axios';

import Loader from './../icons/Loader.vue';

import { mapAndPushHistory } from './../utils/helpers.js';

export default {
    created() {
        window.addEventListener('popstate', this.onPopState);
    },

    beforeDestroy() {
        window.removeEventListener('popstate', this.onPopState);
    },

    data() {
        return {
            state,
            recipes: [],
            recipesInfo: {},
            searchMessage: '',
            debounce: null,
            debounceTimer: 500,
            isSearching: false,

            mapAndPushHistory
        };
    },

    mounted() {
        if (window.location.search) {
            this.getRecipesAndSetFilter(window.location.search.substr(1));
        } else if (window.location.href.indexOf('kategori') != -1) {
            this.getRecipesAndSetFilter('category_slug[]=' + this.getValueAfterLastSlash());
        } else if (window.location.href.indexOf('kost') != -1) {
            this.getRecipesAndSetFilter('tag_slug[]=' + this.getValueAfterLastSlash());
        }
    },

    computed: {
        query: function () {
            return this.state.recipeQueryString;
        },

        showingAmount: function () {
            if (this.recipesInfo.currentPage === this.recipesInfo.lastPage) {
                return this.recipesInfo.total;
            }

            return this.recipesInfo.perPage * this.recipesInfo.currentPage;
        }
    },

    watch: {
        query: function (query) {
            this.getRecipes(query);
        }
    },

    components: {
        Loader
    },

    methods: {
        orderTags: function (tag_titles, tags) {
            var newTagList = [];
            for (var j = 0; j < this.state.filter.tags.length; j++) {
                newTagList.push(tag_titles[tags.indexOf(this.state.filter.tags[j])]);
            }
            return tag_titles;
        },

        getRecipes(query) {

            clearTimeout(this.debounce);

            this.debounce = setTimeout(() => {

                this.isSearching = true;

                axios
                    .get('/recept/api/filter/12?' + query)

                    .then((response) => {
                        this.recipesInfo = response.data.recipesInfo;
                        this.recipes = response.data.recipes;
                        this.searchMessage = response.data.searchMessage;
                        // this.updateUrl(query)
                    })
                    .catch((error) => {
                        this.searchMessage = 'Något gick fel, försök igen!';
                    })
                    .finally(() => {
                        this.isSearching = false
                    });


            }, this.debounceTimer);
        },

        getRecipesAndSetFilter(query) {

            this.isSearching = true;

            axios
                .get('/recept/api/filter/12?' + query)
                .then((response) => {
                    this.state.filter = response.data.filter;
                    this.recipesInfo = response.data.recipesInfo;
                    this.recipes = response.data.recipes;
                    this.searchMessage = response.data.searchMessage;
                })
                .catch((error) => {
                    this.searchMessage = 'Något gick fel, försök igen!';
                })
                .finally(() => {
                    this.isSearching = false
                });
        },

        onPopState(e) {
            if (e.state == null) {
                this.getRecipesAndSetFilter('');
            } else {
                this.getRecipesAndSetFilter(e.state.url.split('sok?')[1]);
            }
        },

        getValueAfterLastSlash() {
            const url = window.location.href;
            const lastSlashIndex = url.lastIndexOf('/');
            return url.substring(lastSlashIndex + 1);
        },

        getPageNumber(queryparams) {
            const params = queryparams.split('&');

            let pair = null,
                data = [];

            params.forEach(function (d) {
                pair = d.split('=');
                data.push({ key: pair[0], value: pair[1] });
            });

            const page = data.find((val) => val.key === 'page');

            return page.value !== undefined ? page.value : '';
        },

        getNextPageUrl() {
            const page = this.getPageNumber(this.recipesInfo.nextPageUrl.split('?')[1]);
            mapAndPushHistory('page', null, page);
        },

        getPrevPageUrl() {
            const page = this.getPageNumber(this.recipesInfo.prevPageUrl.split('?')[1]);
            mapAndPushHistory('page', null, page);
        },

        ratingWidth(ratingAvg, width) {
            return (ratingAvg / 5) * width;
        }

        // updateUrl(query) {
        //     const obj = {title: 'Search', url: '/recept/sok?' + query};
        //     history.pushState(obj, obj.title, obj.url);
        // },
    }
};
</script>
